import { atom } from 'recoil';

import { TFormPageProductInfo } from '@/pages';

export const checkout = atom<TFormPageProductInfo | null>({
  key: 'checkout',
  default: null,
});
